import {
    ClientUpdateHandler, ClientUpdateHandlerRegistry, ClientUpdateRequestType, Collection, StringUtil
} from "@mcleod/core";
import { LayoutDefinitionRetriever } from "./LayoutDefinitionRetriever";

/**
 * This class performs the actions necessary to allow the current tab to clear its layout cache.
 */
export class LayoutCacheClearHandler extends ClientUpdateHandler {
    override get type(): ClientUpdateRequestType {
        return ClientUpdateRequestType.CLEAR_LAYOUT_CACHE;
    }

    override handle(addlInputs: Collection<any>) {
        const singleLayoutToClear = addlInputs?.layoutPath;
        if (StringUtil.isEmptyString(singleLayoutToClear)) {
            LayoutDefinitionRetriever.clearAllFromCache();
        } else {
            LayoutDefinitionRetriever.clearCachedLayout(singleLayoutToClear);
        }
    }
}
ClientUpdateHandlerRegistry.get().register(new LayoutCacheClearHandler());
